import { useNavigate } from "react-router-dom";
import { all, call, put, takeEvery } from "redux-saga/effects";
import axiosMain from "../../../http/axios/axios_main";
import { GET_USER_WISE_BANK_DETAILS } from "../../actionLabels";
import * as BankUpdateDetailAction from "../../actions";

function* getUserWiseBankDetails() {

  let url = window.location.pathname
  let tempData =
    window.location.pathname &&
    window.location.pathname.split("/") &&
    window.location.pathname.split("/")[4];
  let auctionCenterId = tempData && atob(tempData);

  try {
    const response = yield call(
      axiosMain.get,
      `/admin/wallet/updateuserbankaccountregistration/${auctionCenterId}`
    );
    yield put(
      BankUpdateDetailAction.getUserWiseBankDetailsSuccess(response.data)
    ); 
  } catch (error) {
    yield put(BankUpdateDetailAction.getUserWiseBankDetailsFail(error));
  } 
}

export function* bankUpdateDetailSagas() {
  yield all([
    yield takeEvery(GET_USER_WISE_BANK_DETAILS, getUserWiseBankDetails),
  ]);
}

export default bankUpdateDetailSagas;
